import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import { getBackendUrl, LoadStateInfo, loaded, loading, notStarted, error, failedResponse } from "../common";
import { getToken } from "../../features/user/UserAvatar";
import { UserInfo } from "./userSlice";

export interface UserInviteState {
  state: LoadStateInfo;
  request?: ExecuteUserInviteRequest;
  response?: UserInfo[];
}

const initialState: UserInviteState = {
  state: notStarted(),
};

export interface ExecuteUserInviteRequest {
  users: string;
}

export const executeUserInvite = createAsyncThunk(
  "executeUserInvite",
  async (params: ExecuteUserInviteRequest, thunkAPI) => {
    console.debug(`Execute invite users ${params.users}`);

    const response = await fetch(`${getBackendUrl()}/api/user/invite`, {
      method: "POST",
      signal: thunkAPI.signal,
      headers: {
        "Authorization": `Bearer ${getToken()}`,
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        users: params.users
      })
    });

    if(response.ok) {
      return await response.json();
    } else {
      return thunkAPI.rejectWithValue(failedResponse( response ));
    }
  }
);

export const userInviteSlice = createSlice({
  name: "userInviteSlice",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    clean: (state) => {
      state.state = notStarted();
      state.request = undefined;
    },
  },
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: (builder) => {
    builder
      .addCase(executeUserInvite.pending, (state, action) => {
        state.state =  loading();
        state.request = action.meta.arg;
      })
      .addCase(executeUserInvite.fulfilled, (state, action) => {
        console.debug(`${action.type}`);
        state.state =  loaded();
        state.response = action.payload;
      })
      .addCase(executeUserInvite.rejected, (state, action) => {
        state.state = error(action);
      });
    },
});

// export const { } = userInviteSlice.actions;

export const selectUserPermissionInsDel = (state: RootState) => state.userPermissionInsDel;

export default userInviteSlice.reducer;
